(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory("publishModal", Handler)

	function Handler(ModalService, paymentsConfigModal, swurveyAdminService, swurveysStageConfig, confirmationModal) {

		function show(swurvey, SCMultiplyer, user) {

			return ModalService.showModal({
					templateUrl: "app/modals/swurvey/publish/publish.html",
					controller: ['$element', 'close', function ($element, close) {

						var costPerCredit = 0.05;

						var modal = this;

						modal.completionOptions = {
							"100": 100,
							"200": 200,
							"500": 500,
							"1,000": 1000
						};

						modal.completions = 100;

						if (SCMultiplyer == 5) {
						  modal.completions = 25;
							angular.extend(modal.completionOptions, {
								"25": 25,
								"50": 50
							});
						}

						modal.SCMultiplyer = SCMultiplyer;

						modal.user = user;
						modal.swurvey = swurvey;

						console.log(user);

						modal.openPaymentDialog = function () {
							resetLoaders();
							paymentsConfigModal.show(user).then(function (modal) {
								modal.element.modal();
								modal.close.then(function (confirm) {});
							});
						};

						modal.publish = function () {
							resetLoaders();
							confirmationModal.show("Publish",
								"Publish your Swurvey to start collecting data and consume credits. You may make no further changes. Please 'Preview' your Swurvey first!",
								"Publish",
								"Are you sure?").then(function (cmodal) {
									cmodal.element.modal();
									cmodal.close.then(function (confirm) {
										if (confirm === true) {
											modal.publishing = true;
											swurveyAdminService.updateSwurveyState(swurvey.id, "Published", function (err, data) {
												console.log(err, data);
												modal.publishing = false;
												if (err) {
													modal.error = err;
													return console.error(err);
												}
												else {
													$(".modal-backdrop").remove();
													close(data, 500);
												}
											});

										}
									});
								});

						};

						modal.hasEnoughCreditsToPublish = function () {
							 return modal.user.accountBalance >= modal.completions * modal.SCMultiplyer;
						};

						modal.calculateRemainingCredits = function () {
							return modal.user.accountBalance - modal.completions * modal.SCMultiplyer;
						};

						modal.calculateTotalCost = function () {
							return ((modal.completions * modal.SCMultiplyer) * costPerCredit) - (modal.user.accountBalance * costPerCredit);
						};

						modal.close = function () {
							close(null, 500);
							$(".modal-backdrop").remove();
						};

						modal.getPublishTitle = function(){
							if(swurvey.model.paymentTier != 'Free' &&  modal.user.accountBalance == 0)
							{
								return "You cannot publish this paid Swurvey without credits! Please purchase credits to continue";
							}
							else
							{
								return "Publish your Swurvey and Get Your Swurve One!";
							}

						};

						var resetLoaders = function() {
							modal.publishing = false;
							modal.addingCC = false;
							modal.purchasing = false;
							delete modal.error;
						};
					}],
					controllerAs: "modal"
				});
		}

		return {
			show: show
		};
	}
}());
